import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useFacet from '../../../../../../Hooks/Shared/Facet/useFacet';
import useJustForYou from '../../../../../../Hooks/Shared/Facet/useJustForYou';

function thisFacetClicked(event) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.target.parentNode.lastChild.click();
  }
}

function JustForYou() {
  const { shouldShowJustForYou, justForYouChecked, generateLinkForFacetJustForYou, international } = useJustForYou();

  if (!shouldShowJustForYou) {
    return;
  }

  return (
    <>
      <legend className='sr-only'>Just For You</legend>
      <ul className='facet facet-header no-style'>
        <li id='justForYouChkBox' className='ShopNewArrivals'>
          <div className='custom-control custom-checkbox d-inline-block mr-2'>
            <input
              className='custom-control-input'
              type='checkbox'
              role='checkbox'
              readOnly
              aria-checked={justForYouChecked}
              checked={justForYouChecked}
              onKeyUp={thisFacetClicked}
              aria-labelledby='justForYouChkBox'
            ></input>
            <label
              className='custom-control-label-nocolor custom-control-label'
              htmlFor='justForYouChkBox'
              onClick={(e) => e.target.nextElementSibling.click()}
            >
              <span className='sr-only'>Just For You</span>
            </label>
            <Link to={generateLinkForFacetJustForYou()} tabIndex='-1' suppressHydrationWarning>
              Just For You
            </Link>
          </div>
          {!international && (
            <Link
              to={'/my-preferences'}
              tabIndex='-1'
              id='justForYouEditMyPreferences'
              className='btn-tertiary d-inline p-0'
            >
              (Edit)
            </Link>
          )}
        </li>
      </ul>
    </>
  );
}

export function ShopNewArrivals(props) {
  const { newArrivalsChecked, shouldShowNewArrivals, generateLinkForFacet } = useFacet(props);

  return (
    <fieldset suppressHydrationWarning={true}>
      <JustForYou />
      {shouldShowNewArrivals && (
        <>
          <legend className='sr-only'>New Arrivals</legend>
          <ul className='facet facet-header no-style'>
            <li id='newArrivalsChkBox' className='ShopNewArrivals'>
              <div className='custom-control custom-checkbox'>
                <input
                  className='custom-control-input'
                  type='checkbox'
                  role='checkbox'
                  readOnly
                  aria-checked={newArrivalsChecked}
                  checked={newArrivalsChecked}
                  onKeyUp={thisFacetClicked}
                  aria-labelledby='newArrivalsChkBox'
                ></input>
                <label
                  className='custom-control-label-nocolor custom-control-label'
                  htmlFor='newArrivalsChkBox'
                  onClick={(e) => e.target.nextElementSibling.click()}
                >
                  <span className='sr-only'>New Arrivals</span>
                </label>
                <Link
                  to={generateLinkForFacet('dil_newArrival:"1"')}
                  manual_cm_sp={props.widgetData.manualCmSp}
                  tabIndex='-1'
                >
                  New Arrivals
                </Link>
              </div>
            </li>
          </ul>
        </>
      )}
    </fieldset>
  );
}

export default ShopNewArrivals;
